import { render, staticRenderFns } from "./ReceivedBillAmountItem.vue?vue&type=template&id=47e1e3b6&scoped=true&"
import script from "./ReceivedBillAmountItem.vue?vue&type=script&lang=js&"
export * from "./ReceivedBillAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedBillAmountItem.vue?vue&type=style&index=0&id=47e1e3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1e3b6",
  null
  
)

export default component.exports